import React from 'react';
import PropTypes from 'prop-types';
import { ChipGroupAutocomplete } from '@metarouter-private/mr-mui';

import useEditablePipelineTags from './useEditablePipelineTags';
import useEditableTagsAutocomplete from './useEditableTagsAutocomplete';
import TagsSkeleton from '../TagsSkeleton';

export default function EditablePipelineTags({ pipelineId }) {
  const { canEdit, tags, loading, chips, ChipProps, StackProps, handleDelete } = useEditablePipelineTags({
    pipelineId,
  });

  const { onChange, AutocompleteProps } = useEditableTagsAutocomplete({ pipelineId, currentTags: tags, ChipProps });

  if (loading) {
    return <TagsSkeleton />;
  }

  return (
    <ChipGroupAutocomplete
      chips={chips}
      max={1}
      size="small"
      chipMaxWidth={160}
      popoverChipMaxWidth={200}
      ChipProps={ChipProps}
      onDelete={handleDelete}
      onChange={canEdit ? onChange : null}
      AutocompleteProps={AutocompleteProps}
      StackProps={StackProps}
    />
  );
}

EditablePipelineTags.propTypes = {
  pipelineId: PropTypes.string.isRequired,
};
